import React, { Component } from 'react';

// Si cualquier componente de la app truena en render (ej: sesión corrupta
// donde faltan datos esperados en sessionStorage), en vez de dejar la
// pantalla en blanco se limpia todo el storage y se manda al login ("/").
class ErrorBoundary extends Component {

  state = { huboError: false };

  static getDerivedStateFromError(error){
    return { huboError: true };
  }

  componentDidCatch(error, info){
    console.log(error, info);

    try{
      sessionStorage.clear();
      localStorage.clear();
    }catch(e){
      console.log(e);
    }

    window.location.href = "/";
  }

  render(){
    if(this.state.huboError){
      return null;
    }
    return this.props.children;
  }

}

export default ErrorBoundary;
